import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import BrandLogo from "../components/BrandLogo";

export default function Register() {
  const { registerTenant } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ owner_name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await registerTenant(form);
      toast.success(data.message || "Check your email to verify your account.");
      nav(`/login?registered=1&email=${encodeURIComponent(form.email)}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grain-bg p-6 md:p-10">
      <div className="max-w-lg mx-auto">
        <BrandLogo to="/" size="xl" className="mb-8" testid="register-logo" />
        <div className="card-soft p-7 md:p-10">
          <h1 className="font-display font-bold text-3xl">Create your account</h1>
          <p className="mt-2 text-sm" style={{ color: "var(--text-muted)" }}>
            14-day free trial. We&apos;ll email you a verification link before you can sign in.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <Field label="Your name" required v={form.owner_name} onChange={(v) => set("owner_name", v)} placeholder="Full name" testid="reg-owner-name" />
            <Field label="Email" required type="email" v={form.email} onChange={(v) => set("email", v)} placeholder="you@store.com" testid="reg-email" />
            <Field label="Password" required type="password" v={form.password} onChange={(v) => set("password", v)} placeholder="min 6 chars" testid="reg-password" />
            <button disabled={busy} data-testid="register-submit-btn" className="w-full h-12 rounded-md text-white font-semibold tactile-btn" style={{ background: "var(--primary)" }}>
              {busy ? "Creating..." : "Start free trial"}
            </button>
          </form>
          <p className="mt-6 text-sm" style={{ color: "var(--text-muted)" }}>
            Already have an account? <Link className="font-semibold" style={{ color: "var(--primary)" }} to="/login" data-testid="register-login-link">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

function Field({ label, required, v, onChange, placeholder, type = "text", testid }) {
  return (
    <div>
      <label className="text-sm font-medium">{label}{required && <span style={{ color: "var(--primary)" }}> *</span>}</label>
      <input data-testid={testid} required={required} type={type} value={v} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="mt-1.5 w-full h-12 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
    </div>
  );
}
